// removed by extract-text-webpack-plugin
module.exports = {"button":"_3N6VDdmilSvrkP1HTKEOUw","default":"_2XOcwEKRF22_S-1YXw-l86","primary-role":"_36Hq3aiW3BCw2AJnv2Gliq","primaryRole":"_36Hq3aiW3BCw2AJnv2Gliq","primary":"_2Sfj2qPrXXinYVwh2SFOu3","flat":"nGBvBJeJa9JDvNayJfOXl","transparent":"_2pyCa0kPKSKR7ltyCDKJPx","link":"_9bAuap2N6yusrlEHnusy","new-product-button-next":"_2PMY6Fz4xc9eDoDQGr4LpY","newProductButtonNext":"_2PMY6Fz4xc9eDoDQGr4LpY","new-product-button-prev":"_3Vn4CgUXvrk9Jc68RTRPyK","newProductButtonPrev":"_3Vn4CgUXvrk9Jc68RTRPyK"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Button/styles.scss
// module id = 625
// module chunks = 11